/* In-place filtering + sorting for the migrated Best Sellers collection.
 *
 * QA THEME 193347780884 ONLY. Loaded for collection.handle == 'best-sellers' or a filter block with
 * "Premium in-place filtering" enabled (Bills native pilot, ?view=bills-native)
 * (see static-collection.liquid gate, same convention as the premium CSS).
 *
 * The theme's native handlers (FacetedFilterCollection in empire.js.liquid)
 * full-reload by design (window.location.search = ...). This module preempts
 * them with document-level capture listeners + stopPropagation, then swaps
 * only the regions that change. All controls keep real hrefs so no-JS
 * navigation, crawlers, and server-rendered filtered URLs keep working.
 */
(function () {
  'use strict';

  // Scope: Best Sellers premium view only. Search, other collections, and the
  // non-premium best-sellers view are untouched (Globo search intact).
  var params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch (e) { return; }
  // Collection path -> migrated view name. Bills native pilot (QA): ?view=bills-native.
  if (!document.querySelector('[data-pm-native-collection]')) return;

  // NOTE: [data-section-type] also matches the section's JSON data <script>
  // tag, which contains nothing. Resolve the real section wrapper element.
  var sectionDataTag = document.querySelector('script[data-section-type="static-collection-faceted-filters"]') ||
                       document.querySelector('[data-section-type="static-collection-faceted-filters"]');
  if (!sectionDataTag) return;
  var sectionId = sectionDataTag.getAttribute('data-section-id');
  if (!sectionId) return;
  var sectionHost = document.getElementById('shopify-section-' + sectionId);
  if (!sectionHost && sectionDataTag.closest) {
    sectionHost = sectionDataTag.closest('.shopify-section');
  }
  if (!sectionHost || sectionHost.tagName === 'SCRIPT') return;

  // Best-Sellers scoping hook for the premium CSS (flat mobile grid, #7).
  // This module loads only for collection.handle == 'best-sellers', so the
  // class inherently scopes those rules to this collection + view.
  // Keep the live product-card presentation; do not enable pilot grid overrides.
  // Narrowed hook for the scroll-lock coherence rule: only the migrated Best
  // Sellers view (?view=premium, collection.premium.json) keeps the body
  // in-flow on mobile. The module's handle-gating makes this inherently
  // collection-scoped too, so other mobile collections (Globo or otherwise)
  // and the default view keep their exact pre-existing behavior.
  try {
    document.body.classList.add('pif-premium-view');
  } catch (e) {}

  var SEL = {
    row: 'a.collection-filters__filter-link[data-filter-input]',
    chip: 'a.active-filter-group__item[href]',
    clear: 'a.filter-item-clear-all[href]',
    sortBtn: 'button[data-productgrid-trigger-sort-button]:not([disabled])',
    sortSel: 'select[data-productgrid-trigger-sort]',
    page: '.pagination--container a[href]',
    grid: '.pm-native-results',
    count: '.utils-result-count',
    chipsDesk: '.productgrid--filters .active-filter-group',
    chipsMob: '.productgrid--filters--mobile .active-filter-group',
    pagination: '.pm-native-pagination',
    sortList: '[data-productgrid-sort-content] .utils-sortby--modal-list',
    sideTitle: '.productgrid--sidebar-title',
    filterBtn: '.utils-filter-button',
    group: '[data-filter-group]',
    groupTitle: '.collection-filters__filter-title',
    groupList: 'ul[data-filter-group-list]',
    groupTrigger: '[data-filter-group-trigger]'
  };

  var reqSeq = 0;
  var inFlight = null; // { id, controller }
  var cache = new Map(); // url -> section HTML (bounded)
  var CACHE_MAX = 20;
  var FETCH_TIMEOUT = 15000;
  var pendingUrl = null;
  var pendingScrollToTop = false;

  /* Optimistic-selection state (Filters rows + Sort options).
   * renderedUrl: URL of the last successfully applied results (the state every
   *   server-rendered row href was built against).
   * intendedUrl: URL implied by taps whose results have not arrived yet; the
   *   base for the next tap so rapid selections never build from stale hrefs.
   *   null when nothing is outstanding.
   * renderedSort: the last applied sort option value. */
  var renderedUrl = window.location.pathname + window.location.search + window.location.hash;
  var intendedUrl = null;
  var renderedSort = null;

  /* Empire teleports the sidebar filter groups into the body-level
   * .modal--productgrid-filters while the mobile drawer is open, and the sort
   * options into .modal--productgrid-sort while the sort popover is open
   * (single copies, not duplicates), so scope every lookup to the section
   * host PLUS those modals. Desktop (no modals in DOM) is unaffected. */
  var MODAL_SEL = '.modal--productgrid-filters, .modal--productgrid-sort';
  function scopeModals() {
    try { return Array.prototype.slice.call(document.querySelectorAll(MODAL_SEL)); }
    catch (e) { return []; }
  }
  function filtersModal() {
    var ms = scopeModals();
    return ms.length ? ms[0] : null;
  }
  function scopeRoots() {
    var roots = [sectionHost];
    Array.prototype.forEach.call(scopeModals(), function (m) {
      if (m && m !== sectionHost && roots.indexOf(m) === -1) roots.push(m);
    });
    return roots;
  }
  function inScope(el) {
    if (!el) return false;
    if (sectionHost.contains(el)) return true;
    var ms = scopeModals();
    for (var i = 0; i < ms.length; i++) {
      if (ms[i] && ms[i].contains(el)) return true;
    }
    return false;
  }
  function scopeQuery(sel) {
    var roots = scopeRoots();
    for (var i = 0; i < roots.length; i++) {
      var n = roots[i].querySelector(sel);
      if (n) return n;
    }
    return null;
  }
  function scopeQueryAll(sel) {
    var out = [];
    Array.prototype.forEach.call(scopeRoots(), function (r) {
      Array.prototype.forEach.call(r.querySelectorAll(sel), function (n) { out.push(n); });
    });
    return out;
  }

  /* ---------- error notice (injected once, hidden until needed) ---------- */
  var errBox = null;
  function errorBox() {
    if (errBox) return errBox;
    errBox = document.createElement('div');
    errBox.className = 'pif-error';
    errBox.setAttribute('role', 'alert');
    errBox.hidden = true;
    var msg = document.createElement('span');
    msg.className = 'pif-error__text';
    msg.textContent = 'Could not update the results. Check your connection and try again.';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pif-error__retry';
    btn.textContent = 'Retry';
    btn.addEventListener('click', function () {
      if (pendingUrl) loadState(pendingUrl, { push: true, retry: true });
    });
    errBox.appendChild(msg);
    errBox.appendChild(btn);
    var anchor = sectionHost.querySelector('.productgrid--utils-container') ||
                 sectionHost.querySelector('.productgrid--wrapper');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(errBox, anchor.nextSibling);
    else sectionHost.insertBefore(errBox, sectionHost.firstChild);
    return errBox;
  }
  function showError(on) { errorBox().hidden = !on; }

  function setLoading(on) {
    sectionHost.classList.toggle('pif-loading', on);
    var grid = scopeQuery(SEL.grid);
    if (grid) {
      if (on) {
        grid.setAttribute('aria-busy', 'true');
        if (!grid.style.minHeight) grid.dataset.pifMinH = '1';
        grid.style.minHeight = grid.offsetHeight + 'px';
      } else {
        grid.removeAttribute('aria-busy');
        grid.style.minHeight = '';
      }
    }
  }

  /* Native selects can match :focus-visible after pointer use, including
   * when the browser consumes the click that dismisses their options menu.
   * Track input mode outside the swapped toolbar so AJAX focus restoration
   * preserves keyboard navigation without adding a ring after mouse use. */
  document.addEventListener('pointerdown', function (e) {
    sectionHost.setAttribute('data-pm-toolbar-input', 'pointer');
    var active = document.activeElement;
    if (active && active.matches('.pm-native-toolbar select') &&
        sectionHost.contains(active) && !active.contains(e.target)) {
      active.blur();
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.isComposing || e.metaKey || e.ctrlKey || e.altKey ||
        /^(Shift|Control|Alt|Meta)$/.test(e.key)) return;
    sectionHost.removeAttribute('data-pm-toolbar-input');
  }, true);

  /* ---------- focus + group state capture ---------- */
  function captureFocus() {
    var a = document.activeElement;
    if (!a || a === document.body) return null;
    if (a.matches(SEL.row)) {
      return { kind: 'row', handle: a.getAttribute('data-handle'), value: a.getAttribute('data-value') };
    }
    if (a.matches(SEL.chip)) {
      var t = a.querySelector('.active-filter-text');
      return { kind: 'chip', text: t ? t.textContent.trim() : null };
    }
    if (a.matches(SEL.clear)) return { kind: 'clear' };
    if (a.matches(SEL.sortSel)) return { kind: 'sort' };
    if (a.matches(SEL.page)) return { kind: 'page', href: a.getAttribute('href') };
    if (a.matches(SEL.sortBtn)) return { kind: 'sortbtn', value: a.value };
    return null;
  }
  function firstRendered(list) {
    for (var i = 0; i < list.length; i++) {
      try { if (list[i].getClientRects().length) return list[i]; } catch (e) {}
    }
    return null;
  }
  function restoreFocus(desc) {
    if (!desc) return false;
    var el = null;
    try {
      if (desc.kind === 'row' && desc.handle) {
        el = scopeQuery(SEL.row + '[data-handle="' + CSS.escape(desc.handle) + '"]' +
          (desc.value ? '[data-value="' + CSS.escape(desc.value) + '"]' : ''));
      } else if (desc.kind === 'chip' && desc.text) {
        var chips = Array.prototype.slice.call(scopeQueryAll(SEL.chip));
        el = chips.filter(function (c) {
          var t = c.querySelector('.active-filter-text');
          return t && t.textContent.trim() === desc.text;
        })[0] || null;
      } else if (desc.kind === 'clear') {
        el = firstRendered(scopeQueryAll(SEL.clear));
      } else if (desc.kind === 'sort') {
        el = scopeQuery(SEL.sortSel);
      } else if (desc.kind === 'page' && desc.href) {
        el = scopeQuery(SEL.page + '[href="' + CSS.escape(desc.href) + '"]');
      } else if (desc.kind === 'sortbtn' && desc.value) {
        el = scopeQuery(SEL.sortBtn + '[value="' + CSS.escape(desc.value) + '"]');
      }
    } catch (e) { el = null; }
    if (el) { el.focus({ preventScroll: true }); return true; }
    // Chip just removed, or Clear all that hid itself: move focus to a
    // rendered Clear all, else the open drawer's Show-results button, else
    // the count.
    if (desc.kind === 'chip' || desc.kind === 'clear') {
      var fallback = firstRendered(scopeQueryAll(SEL.clear)) ||
        firstRendered(scopeQueryAll('.modal--productgrid-filters > .pif-drawer-footer .pif-drawer-footer__btn')) ||
        scopeQuery(SEL.count);
      if (fallback) {
        if (!fallback.matches('a[href], button') && !fallback.hasAttribute('tabindex')) fallback.setAttribute('tabindex', '-1');
        fallback.focus({ preventScroll: true });
        return true;
      }
    }
    return false;
  }
  function openGroupTitles() {
    var out = [];
    Array.prototype.forEach.call(scopeQueryAll(SEL.group), function (g) {
      var trig = g.querySelector(SEL.groupTrigger);
      var title = g.querySelector(SEL.groupTitle);
      if (trig && trig.getAttribute('aria-expanded') === 'true' && title) out.push(title.textContent.trim());
    });
    return out;
  }

  /* ---------- region swap ---------- */
  function syncChipRow(src, containerSel, anchorSel) {
    var srcCont = src.querySelector(containerSel);
    var dstCont = scopeQuery(containerSel);
    if (srcCont && dstCont) {
      var su = srcCont.querySelector('ul');
      var du = dstCont.querySelector('ul');
      if (su && du && du.innerHTML !== su.innerHTML) du.innerHTML = su.innerHTML;
      else if (!su && !du) { /* same empty state */ }
      else if (su && !du) dstCont.innerHTML = srcCont.innerHTML;
      // Fresh payload chipless (e.g. Clear all renders the empty reserve
      // shell) while the drawer still lists chips: empty the list in place.
      // The shell keeps its reserved height so the options never shift.
      else if (!su && du) du.innerHTML = '';
      return;
    }
    if (srcCont && !dstCont) {
      var anchor = scopeQuery(anchorSel);
      var node;
      try { node = document.adoptNode(srcCont); }
      catch (e) {
        var tmp = document.createElement('div');
        tmp.innerHTML = srcCont.outerHTML;
        node = tmp.firstChild;
      }
      if (node && anchor && anchor.parentNode) anchor.parentNode.insertBefore(node, anchor);
      return;
    }
    if (!srcCont && dstCont && dstCont.parentNode) dstCont.parentNode.removeChild(dstCont);
  }

  function setHTML(scope, selector, html) {
    var nodes = scopeQueryAll(selector);
    var changed = false;
    Array.prototype.forEach.call(nodes, function (n) {
      if (n.innerHTML !== html) { n.innerHTML = html; changed = true; }
    });
    return changed;
  }
  function applyState(html, focusDesc, openTitles, url) {
    var doc;
    try {
      doc = new DOMParser().parseFromString(html, 'text/html');
    } catch (e) { return false; }
    // NOTE: the payload's first [data-section-type] node is the section's JSON
    // data <script> tag, not a container. Scope to the section wrapper div.
    var src = null;
    try { src = doc.querySelector('#shopify-section-' + CSS.escape(sectionId)); } catch (e) { src = null; }
    if (!src) src = doc.querySelector('div.shopify-section');
    if (!src) src = doc;
    var grid = src.querySelector(SEL.grid);
    if (!grid) return false; // not a usable section payload

    setHTML(sectionHost, SEL.grid, grid.innerHTML);

    var limitSrc = src.querySelector('[data-pm-native-limit]');
    var limitDst = scopeQuery('[data-pm-native-limit]');
    if (limitSrc && limitDst) limitDst.value = limitSrc.value;
    var count = src.querySelector(SEL.count);
    if (count) setHTML(sectionHost, SEL.count, count.innerHTML);

    // Facet lists: match groups by title, replace list contents only so
    // accordion containers, triggers, and drawer scroll position survive.
    var srcGroups = src.querySelectorAll(SEL.group);
    var dstGroups = scopeQueryAll(SEL.group);
    var byTitle = {};
    Array.prototype.forEach.call(dstGroups, function (g) {
      var t = g.querySelector(SEL.groupTitle);
      if (t) byTitle[t.textContent.trim()] = g;
    });
    Array.prototype.forEach.call(srcGroups, function (sg) {
      var st = sg.querySelector(SEL.groupTitle);
      var sl = sg.querySelector(SEL.groupList);
      if (!st || !sl) return;
      var dg = byTitle[st.textContent.trim()];
      if (!dg) return;
      // Keep accordion nodes and drawer position while a no-op facet becomes
      // useful again (or vice versa) after changing another selection.
      dg.hidden = sg.hidden;
      if (sg.hidden) dg.style.setProperty('display', 'none', 'important');
      else dg.style.removeProperty('display');
      var dl = dg.querySelector(SEL.groupList);
      if (!dl || dl.innerHTML === sl.innerHTML) return;
      dl.innerHTML = sl.innerHTML;
      // Accordion may hold a stale explicit height from the old content.
      if (openTitles.indexOf(st.textContent.trim()) !== -1) {
        dl.style.height = '';
        dl.style.maxHeight = '';
      }
    });

    // Active-filter chip rows only render server-side when filters are active,
    // so insert/remove the whole container (not just its list contents).
    // Desktop row lives between the toolbar and the grid; mobile row sits
    // ahead of the drawer/sidebar filter form.
    syncChipRow(src, '.productgrid--filters', SEL.grid);
    syncChipRow(src, '.productgrid--filters--mobile', '.filter-form');

    var pag = src.querySelector(SEL.pagination);
    var dstPag = scopeQuery(SEL.pagination);
    if (pag && dstPag) { if (dstPag.innerHTML !== pag.innerHTML) dstPag.innerHTML = pag.innerHTML; }
    else if (!pag && dstPag) dstPag.innerHTML = '';

    var sl2 = src.querySelector(SEL.sortList);
    if (sl2) setHTML(sectionHost, SEL.sortList, sl2.innerHTML);

    var st2 = src.querySelector(SEL.sideTitle);
    if (st2) setHTML(sectionHost, SEL.sideTitle, st2.innerHTML);

    // Drawer footer Clear all (the drawer has no chip row): the footer is not
    // part of any swapped region, so mirror href + visibility onto the
    // original and the open-drawer clone.
    var sClear = src.querySelector('.pif-drawer-footer__clear');
    if (sClear) {
      Array.prototype.forEach.call(scopeQueryAll('.pif-drawer-footer__clear'), function (a) {
        if (a.getAttribute('href') !== sClear.getAttribute('href')) a.setAttribute('href', sClear.getAttribute('href'));
        if (a.hidden !== sClear.hidden) a.hidden = sClear.hidden;
      });
    }

    var fb = src.querySelector(SEL.filterBtn);
    var dfb = scopeQuery(SEL.filterBtn);
    if (fb && dfb) {
      if (dfb.innerHTML !== fb.innerHTML) dfb.innerHTML = fb.innerHTML;
      Array.prototype.forEach.call(fb.attributes, function (at) {
        if (at.name === 'aria-label') dfb.setAttribute('aria-label', at.value);
      });
    }

    // Keep the desktop select value in sync without replacing the node
    // (preserves any third-party bindings on it). Read from the target URL:
    // location is still the previous state at this point.
    try {
      var sv = new URL(url, window.location.origin).searchParams.get('sort_by');
      var sel = scopeQuery(SEL.sortSel);
      if (sel && sv && sel.value !== sv) sel.value = sv;
    } catch (e) { /* ignore */ }

    // Section unload destroys the open Filters drawer's Modal (close, unlock,
    // scroll restore) and load builds a new one, so while the drawer is open
    // the rebind waits for its close. Nothing behind the drawer needs it
    // meanwhile: the cards are covered, and filter rows, chips, and sort
    // buttons are handled by this module's capture listeners on the new
    // nodes. The Sort sheet keeps its existing apply-closes behavior.
    if (filtersModalOpen(filtersModalEl())) {
      rebindPending = true;
    } else {
      rebindSection(openTitles);
    }
    restoreFocus(focusDesc);
    return true;
  }

  // Rebind empire behaviors (per-card quickshop/ATC, accordions) via the
  // theme-editor lifecycle: unload tears down the old instance cleanly, load
  // constructs exactly one fresh instance on the new nodes. Bound nodes carry
  // data-pm-grid-bound so nothing double-binds. Section load re-asserts
  // empire's toolbar top, so the dock is re-synced before the next paint.
  var rebindPending = false;
  function rebindSection(openTitles) {
    rebindPending = false;
    reinitSection();
    try { syncToolbarDock(); } catch (e) {}
    reopenGroups(openTitles);
  }

  function sectionEvent(name) {
    try {
      var wrapper = document.getElementById('shopify-section-' + sectionId) || sectionHost;
      wrapper.dispatchEvent(new CustomEvent(name, {
        bubbles: true,
        detail: { sectionId: sectionId }
      }));
    } catch (e) { /* ignore */ }
  }
  function reinitSection() {
    sectionEvent('shopify:section:unload');
    sectionEvent('shopify:section:load');
  }
  function setGroupOpen(group, open) {
    var button = group.querySelector(SEL.groupTrigger);
    var list = group.querySelector(SEL.groupList);
    if (!button || !list) return;
    if (group.hasAttribute('data-pm-filter-open')) group.setAttribute('data-pm-filter-open', String(open));
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    button.classList.toggle('productgrid--sidebar-button-active', open);
    list.setAttribute('data-accordion-state', open ? 'open' : 'closed');
    list.removeAttribute('data-accordion-animation');
    list.style.height = open ? 'auto' : '';
    list.style.maxHeight = open ? 'none' : '';
  }

  function reopenGroups(openTitles) {
    if (!openTitles || !openTitles.length) return;
    Array.prototype.forEach.call(scopeQueryAll(SEL.group), function (g) {
      var title = g.querySelector(SEL.groupTitle);
      var trig = g.querySelector(SEL.groupTrigger);
      if (!title || !trig) return;
      var isOpen = openTitles.indexOf(title.textContent.trim()) !== -1;
      setGroupOpen(g, isOpen);
    });
  }

  /* ---------- sticky toolbar dock (#2) + drawer footer count (#5) ---------- */
  var mqNarrow = null;
  try { mqNarrow = window.matchMedia('(max-width: 859px), (max-width: 1024px) and (pointer: coarse)'); } catch (e) { mqNarrow = null; }

  /* Empire docks the bar at the full header height because body carries
   * site-header-sticky, but the header is position:relative and scrolls off,
   * so the bar floated mid-viewport over product info. Sync top to the live
   * visible header bottom (0 once it scrolls off, so show/hide headers just
   * work). Narrow-only; empire owns desktop and re-asserts its own value on
   * breakpoint re-init. Also nudges the intersection sentinel so the stuck
   * shadow timing stays honest. */
  function syncToolbarDock() {
    var bar = sectionHost.querySelector('[data-sticky-utils]');
    if (!mqNarrow || !mqNarrow.matches) {
      if (bar && bar.classList.contains('pm-native-toolbar')) {
        ['position','left','width','margin-bottom','top'].forEach(function(key){bar.style.removeProperty(key);});
        var holder = sectionHost.querySelector('[data-pm-toolbar-holder]');
        if (holder) holder.style.height = '0px';
        bar.classList.remove('pm-native-toolbar-docked');
      }
      return;
    }
    if (!bar) return;
    var hdr = document.querySelector('[data-site-header-main]');
    var bottom = 0;
    if (hdr) {
      try { bottom = Math.max(0, Math.ceil(hdr.getBoundingClientRect().bottom)); }
      catch (e) { bottom = 0; }
    }
    if (bar.classList.contains('pm-native-toolbar')) {
      var holder = sectionHost.querySelector('[data-pm-toolbar-holder]');
      if (!holder) {
        holder = document.createElement('div');
        holder.setAttribute('data-pm-toolbar-holder', '');
        bar.parentNode.insertBefore(holder, bar);
      }
      var bounds = holder.getBoundingClientRect();
      var wrap = bar.parentNode.getBoundingClientRect();
      var height = bar.offsetHeight;
      var fixed = bounds.top < bottom + 8 && wrap.bottom > bottom + height + 28;
      if (fixed) {
        holder.style.height = (height + 20) + 'px';
        bar.style.position = 'fixed';
        bar.style.left = bounds.left + 'px';
        bar.style.width = bounds.width + 'px';
        bar.style.marginBottom = '0px';
        bar.classList.add('pm-native-toolbar-docked');
      } else {
        holder.style.height = '0px';
        bar.style.removeProperty('position');
        bar.style.removeProperty('left');
        bar.style.removeProperty('width');
        bar.style.removeProperty('margin-bottom');
        bar.classList.remove('pm-native-toolbar-docked');
      }
    }
    var top = (bottom + (bar.classList.contains('pm-native-toolbar') ? 8 : 0)) + 'px';
    if (bar.style.top !== top) bar.style.top = top;
    var tgt = sectionHost.querySelector('[data-utils-intersection-target]');
    if (tgt) {
      var tt = bottom > 0 ? '-' + top : '0';
      if (tgt.style.top !== tt) tgt.style.top = tt;
    }
  }
  var dockQueued = false;
  function queueDock() {
    if (dockQueued) return;
    dockQueued = true;
    var run = function () {
      dockQueued = false;
      try { syncToolbarDock(); } catch (e) {}
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else setTimeout(run, 0);
  }
  try {
    window.addEventListener('scroll', queueDock, { passive: true });
    window.addEventListener('resize', queueDock);
    if (mqNarrow) {
      if (mqNarrow.addEventListener) mqNarrow.addEventListener('change', queueDock);
      else if (mqNarrow.addListener) mqNarrow.addListener(queueDock);
    }
  } catch (e) {}

  /* "Show N products" footer label from the live toolbar result count
   * ("36 products"). Falls back to the static liquid "Show results" text
   * when no count parses. Filtering keeps updating in place; the button
   * itself is a native data-modal-close so close/focus-restore stay native. */
  function updateShowCount() {
    var labels = scopeQueryAll('.pif-drawer-footer__label');
    if (!labels.length) return;
    var countEl = scopeQuery(SEL.count);
    var txt = countEl ? countEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var m = txt.match(/(\d[\d,]*)/);
    if (!m) return; // keep static fallback
    var n = parseInt(m[1].replace(/,/g, ''), 10);
    var label = 'Show ' + m[1] + (n === 1 ? ' product' : ' products');
    Array.prototype.forEach.call(labels, function (el) {
      if (el.textContent !== label) el.textContent = label;
    });
  }

  /* The server-rendered footer lives inside the teleported sidebar content
   * (nested under .modal-inner, overflow:hidden), where no sticky/fixed
   * positioning can pin it to the visible sheet area on short viewports.
   * Clone it as a direct child of the scrolling .modal on open — the CSS
   * shows only that direct-child clone (sticky bottom) and hides the
   * in-content original — and remove the clone on close. The original node
   * is never moved, so empire teleports, section re-inits, and modal
   * teardown (which can destroy the shell mid-swap) stay safe: the next
   * open simply re-clones. */
  function footerClone() {
    var m = filtersModalEl();
    if (!m) return null;
    var kids = m.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].classList && kids[i].classList.contains('pif-drawer-footer')) return kids[i];
    }
    return null;
  }
  function syncFooterClone(retry) {
    var m = filtersModalEl();
    if (!m) return;
    if (filtersModalOpen(m)) {
      if (footerClone()) return;
      var orig = scopeQuery('.modal--productgrid-filters .pif-drawer-footer:not([data-pif-clone])') ||
                 scopeQuery('.productgrid--sidebar .pif-drawer-footer:not([data-pif-clone])') ||
                 scopeQuery('.filter-form .pif-drawer-footer:not([data-pif-clone])');
      if (!orig) {
        // Modal visible but content not teleported yet (open transition):
        // bounded re-check, abandoned if a newer filter request supersedes.
        if ((retry || 0) < 10) {
          var nid = reqSeq;
          setTimeout(function () {
            if (nid !== reqSeq) return;
            try { syncFooterClone((retry || 0) + 1); } catch (e) {}
          }, 250);
        }
        return;
      }
      var c = orig.cloneNode(true);
      c.setAttribute('data-pif-clone', '1');
      m.appendChild(c);
      updateShowCount();
    } else {
      var stale = footerClone();
      if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
    }
  }
  try {
    // Also runs the rebind deferred while the drawer was open. This callback
    // is a microtask after empire's synchronous close (content teleported
    // back, unlock, scroll restore, focus), so nothing is torn down mid-close.
    var footerObs = new MutationObserver(function () {
      try { syncFooterClone(); } catch (e) {}
      if (rebindPending && !filtersModalOpen(filtersModalEl())) {
        try { rebindSection(openGroupTitles()); } catch (e) { rebindPending = false; }
      }
    });
    footerObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  } catch (e) { /* clone falls back to in-content footer */ }

  /* Hold-offset for empire's scroll freeze (open flash/jump on Filters/Sort).
   * Root cause (proven live 2026-10-07): HulkApps order-lookup CSS pins
   * body{position:absolute!important;overflow-y:scroll!important} globally, so
   * the page scrolls via root overflow from an out-of-flow body. The modal
   * open flips body back in-flow (theme fixed pin / coherence static rule) in
   * the SAME frame as its DOM churn (sidebar moved into the shown fixed
   * modal + inner margin write); the first recalc after html.scroll-locked
   * then discards the offset 400->0 with zero scroll-API calls (full
   * scrollTo/scroll/scrollBy/scrollIntoView/focus spy + scrollTop setter
   * traps stay silent, scrollHeight intact). Flip alone and churn alone each
   * preserve Y — only the composition resets. So restore the sampled Y here:
   * this observer is a microtask, runs before first paint, and programmatic
   * scrollTo still works while locked (html hidden blocks only user scroll).
   * First painted frame is therefore the frozen pre-open view on all paths
   * (static or fixed body, desktop or mobile, nested modals). The top hold
   * stays for fixed-body paths. Y is sampled on pre-open input (capture
   * phase, always before empire's open handler), never read back after. */
  var nativeModalY = null;
  var nativeBodyStyles = null;
  var freezeProperties = ['position','top','left','right','width','overflow'];
  function captureNativeModalPosition(event) {
    if (nativeBodyStyles || !(event.target instanceof Element)) return;
    if (event.target.closest('[data-productgrid-trigger-filters],[data-productgrid-modal-sort]')) nativeModalY = window.pageYOffset;
  }
  document.addEventListener('pointerdown',captureNativeModalPosition,true);
  document.addEventListener('click',captureNativeModalPosition,true);
  function syncNativeModalLock() {
    var modal = document.querySelector('.modal--productgrid-filters,.modal--productgrid-sort');
    var open = modal && document.body.classList.contains('modal-visible') && document.documentElement.classList.contains('scroll-locked');
    if (open && nativeModalY !== null && !nativeBodyStyles) {
      nativeBodyStyles = {};
      freezeProperties.forEach(function(key){nativeBodyStyles[key] = [document.body.style.getPropertyValue(key),document.body.style.getPropertyPriority(key)];});
      document.body.style.setProperty('position','fixed','important');
      document.body.style.setProperty('top',(-nativeModalY)+'px','important');
      document.body.style.setProperty('left','0px','important');
      document.body.style.setProperty('right','0px','important');
      document.body.style.setProperty('width','100%','important');
      document.body.style.setProperty('overflow','hidden','important');
    } else if (!open && nativeBodyStyles) {
      var restoreY = nativeModalY;
      var saved = nativeBodyStyles;
      nativeBodyStyles = null; nativeModalY = null;
      freezeProperties.forEach(function(key){if(saved[key][0])document.body.style.setProperty(key,saved[key][0],saved[key][1]);else document.body.style.removeProperty(key);});
      window.scrollTo(0,restoreY || 0);
      requestAnimationFrame(function(){if(!document.body.classList.contains('modal-visible')){window.scrollTo(0,restoreY || 0);queueDock();}});
    }
  }
  var nativeModalObserver = new MutationObserver(syncNativeModalLock);
  nativeModalObserver.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
  nativeModalObserver.observe(document.body,{attributes:true,attributeFilter:['class']});

  function fetchSection(url, signal) {    var u = new URL(url, window.location.origin);
    var fullWidth = sectionHost.querySelector('.collection-template-full-width, .collection-close-ups-full-width');
    u.searchParams.set('section_id', fullWidth ? sectionId : 'static-collection');
    return fetch(u.toString(), {
      signal: signal,
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (resp) {
      if (!resp.ok) throw new Error('bad status ' + resp.status);
      return resp.text();
    });
  }

  /* Empire's section unload/load cycle (reinitSection) closes the mobile
   * filter drawer, so capture its open state + scroll across the swap and
   * restore it afterwards — unless the shopper closed it mid-flight. */
  function filtersModalEl() {
    try { return document.querySelector('.modal--productgrid-filters'); }
    catch (e) { return null; }
  }
  function filtersModalOpen(m) {
    if (!m) return false;
    try {
      return getComputedStyle(m).display !== 'none' &&
        document.body.classList.contains('modal-visible');
    } catch (e) { return false; }
  }
  /* A group that was open across a swap or a section rebind can come back
   * collapsed-but-marked-open
   * (aria-expanded=true with a 0px list: a stale transient
   * data-accordion-animation pins height to var(--menu-open-height), measured
   * against the old hidden content). Fix it with instant attribute surgery —
   * drop the stale animation flag and explicit heights so the
   * [data-accordion-state=open] rule (height:auto) applies immediately.
   * No trigger clicks: nothing visibly collapses and reopens. No-op when
   * everything already renders. */
  function normalizeModalGroups(id) {
    if (id !== undefined && id !== reqSeq) return;
    var m = filtersModalEl();
    if (!m || !filtersModalOpen(m)) return;
    Array.prototype.forEach.call(m.querySelectorAll(SEL.group), function (g) {
      var trig = g.querySelector(SEL.groupTrigger);
      var acc = g.querySelector('[data-accordion-content]') || g.querySelector(SEL.groupList);
      if (!trig || !acc) return;
      if (trig.getAttribute('aria-expanded') !== 'true') return;
      if (acc.getAttribute('data-accordion-state') !== 'open') {
        acc.setAttribute('data-accordion-state', 'open');
      }
      var height = 0;
      try { height = acc.getBoundingClientRect().height; } catch (e) {}
      if (height === 0) {
        acc.removeAttribute('data-accordion-animation');
        acc.style.height = '';
        acc.style.maxHeight = '';
      }
    });
  }

  /* ---------- optimistic UI (instant tap feedback) ---------- */
  var SKIP_PARAMS = { page: 1, view: 1 };
  function entriesOf(url) {
    var out = [];
    try { new URL(url, window.location.origin).searchParams.forEach(function (v, k) { out.push([k, v]); }); } catch (e) {}
    return out;
  }
  function sameEntry(a, b) { return a[0] === b[0] && a[1] === b[1]; }
  function hasEntry(list, e) { return list.some(function (x) { return sameEntry(x, e); }); }
  // What the row's ORIGINAL (server-rendered) link adds/removes relative to
  // the last applied URL. Works for twin-collapsed rows too, because it is
  // derived from the link itself rather than from the row's label.
  function rowDelta(row) {
    var href = row.getAttribute('data-pif-href0') || row.getAttribute('href');
    var base = entriesOf(renderedUrl).filter(function (e) { return !SKIP_PARAMS[e[0]]; });
    var tgt = entriesOf(href).filter(function (e) { return !SKIP_PARAMS[e[0]]; });
    return {
      adds: tgt.filter(function (e) { return !hasEntry(base, e); }),
      removes: base.filter(function (e) { return !hasEntry(tgt, e); })
    };
  }
  function applyDelta(entries, delta, reverse) {
    var adds = reverse ? delta.removes : delta.adds;
    var rems = reverse ? delta.adds : delta.removes;
    var out = entries.filter(function (e) { return e[0] !== 'page' && !hasEntry(rems, e); });
    adds.forEach(function (a) {
      if (hasEntry(out, a)) return;
      var at = 0;
      out.forEach(function (e, i) { if (e[0].indexOf('filter.') === 0) at = i + 1; });
      out.splice(at, 0, a);
    });
    return out;
  }
  function urlFromEntries(entries) {
    var sp = new URLSearchParams();
    entries.forEach(function (e) { sp.append(e[0], e[1]); });
    var q = sp.toString();
    return window.location.pathname + (q ? '?' + q : '');
  }
  function paintRow(row, active) {
    if (active) row.setAttribute('data-filter-active', ''); else row.removeAttribute('data-filter-active');
    var li = row.closest ? row.closest('li') : null;
    if (li) {
      li.classList.toggle('collection-filters__filter-list-item--active', active);
      li.setAttribute('data-filter-open', active ? 'true' : 'false');
    }
    Array.prototype.forEach.call(row.querySelectorAll('svg.checkmark, svg.checkmark path'), function (n) {
      n.setAttribute('data-animation-state', active ? 'checked' : 'unchecked');
    });
    var text = row.querySelector('.collection-filters__filter-list-item-text');
    if (text) {
      var sr = null;
      Array.prototype.forEach.call(text.querySelectorAll('.visually-hidden'), function (n) {
        if (n.textContent.trim() === ', selected') sr = n;
      });
      if (active && !sr) {
        sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = ', selected';
        text.appendChild(sr);
      } else if (!active && sr && sr.parentNode) {
        sr.parentNode.removeChild(sr);
      }
    }
  }
  function clearOptimisticMarks() {
    Array.prototype.forEach.call(scopeQueryAll('a[data-pif-opt]'), function (r) {
      r.removeAttribute('data-pif-opt');
      r.removeAttribute('data-pif-href0');
    });
  }
  // Genuine failure: put every row/sort option the shopper tapped since the
  // last applied results back to that applied state.
  function restoreOptimistic() {
    Array.prototype.forEach.call(scopeQueryAll('a[data-pif-opt]'), function (r) {
      paintRow(r, r.getAttribute('data-pif-opt') === 'on');
      r.removeAttribute('data-pif-opt');
      r.removeAttribute('data-pif-href0');
    });
    initSortState();
    if (renderedSort) paintSort(renderedSort);
    intendedUrl = null;
  }

  function sortButtons() { return scopeQueryAll('[data-productgrid-trigger-sort-button]'); }
  function activeSortValue() {
    var list = scopeQueryAll('.utils-sortby--modal-button--active');
    return list.length ? list[0].value : null;
  }
  function paintSort(value) {
    Array.prototype.forEach.call(sortButtons(), function (b) {
      var on = b.value === value;
      b.classList.toggle('utils-sortby--modal-button--active', on);
      b.disabled = on;
      if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
    var sel = scopeQuery(SEL.sortSel);
    if (sel && sel.value !== value) sel.value = value;
  }
  // Starts the Sort sheet's native close (same path as its X), so focus
  // returns to the Sort button and scroll restore are Empire's own.
  function closeSortSheet() {
    var m = document.querySelector('.modal--productgrid-sort');
    if (!m || !document.body.classList.contains('modal-visible')) return false;
    var x = m.querySelector('[data-modal-close]');
    if (!x) return false;
    x.click();
    return true;
  }

  /* Pagination starts at the page top only after the new results succeed. */
  function scrollPaginationToTop(id) {
    var heading = document.querySelector('#site-main h1');
    if (heading) {
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    window.requestAnimationFrame(function () {
      // A newer request owns the viewport if shoppers navigate again quickly.
      if (id === reqSeq) window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    });
  }

  function loadState(url, opts) {
    opts = opts || {};
    if (!opts.retry) pendingScrollToTop = !!opts.scrollToTop;
    if (!opts.optimistic) intendedUrl = null;
    var id = ++reqSeq;
    if (inFlight && inFlight.controller) { try { inFlight.controller.abort(); } catch (e) {} }
    pendingUrl = url;
    var focusDesc = opts.focusDesc !== undefined ? opts.focusDesc : captureFocus();
    var openTitles = openGroupTitles();
    showError(false);
    setLoading(true);

    var cached = !opts.retry && cache.get(url);
    var done = function (html) {
      if (id !== reqSeq) return; // stale response: never overwrite newer state
      var ok = applyState(html, focusDesc, openTitles, url);
      setLoading(false);
      inFlight = null;
      if (!ok) { restoreOptimistic(); showError(true); return; }
      renderedUrl = url;
      intendedUrl = null;
      clearOptimisticMarks();
      renderedSort = new URL(url, window.location.origin).searchParams.get('sort_by') || activeSortValue() || renderedSort;
      if (renderedSort) paintSort(renderedSort); // adds aria-current to the server-marked option
      if (cache.size >= CACHE_MAX) cache.delete(cache.keys().next().value);
      cache.set(url, html);
      pendingUrl = null;
      queueDock();
      updateShowCount();
      normalizeModalGroups(id);
      syncFooterClone();
      if (opts.push !== false) {
        try { window.history.pushState({ pif: true, url: url }, '', url); } catch (e) {}
      }
      if (pendingScrollToTop) {
        pendingScrollToTop = false;
        scrollPaginationToTop(id);
      }
    };
    var fail = function (err) {
      if (id !== reqSeq) return;
      // Superseded by a newer selection: stay silent. Anything else
      // (network failure, bad status, timeout) shows the recoverable error;
      // controls + results are untouched and Retry re-runs pendingUrl.
      if (err && err.name === 'Superseded') { setLoading(false); inFlight = null; return; }
      setLoading(false);
      inFlight = null;
      restoreOptimistic();
      showError(true);
    };

    if (cached) { done(cached); return; }
    var controller = new AbortController();
    inFlight = { id: id, controller: controller };
    var timedOut = false;
    var timer = setTimeout(function () { timedOut = true; try { controller.abort(); } catch (e) {} }, FETCH_TIMEOUT);
    fetchSection(url, controller.signal).then(function (text) {
      clearTimeout(timer);
      done(text);
    }).catch(function (err) {
      clearTimeout(timer);
      if (err && err.name === 'AbortError' && !timedOut) { err = { name: 'Superseded' }; }
      fail(err);
    });
  }

  function targetFromLink(href, resetPage) {
    var u = new URL(href, window.location.origin);
    if (resetPage) u.searchParams.delete('page');
    // Clear-all links at /collections/best-sellers omit ?view=premium; keep
    // the migrated view so state stays in place.
    var currentView = new URL(intendedUrl || renderedUrl, window.location.origin).searchParams.get('view');
    if (!u.searchParams.get('view') && currentView) u.searchParams.set('view', currentView);
    return u.pathname + u.search + u.hash;
  }

  /* ---------- interception (capture: runs before empire's bubble handlers) ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!(t instanceof Element)) return;

    var groupButton = t.closest ? t.closest(SEL.groupTrigger) : null;
    if (groupButton && inScope(groupButton)) {
      e.preventDefault(); e.stopPropagation();
      setGroupOpen(groupButton.closest(SEL.group), groupButton.getAttribute('aria-expanded') !== 'true');
      return;
    }
    var row = t.closest ? t.closest(SEL.row) : null;
    if (row && inScope(row)) {
      if (row.hasAttribute('data-disabled')) return;
      e.preventDefault();
      e.stopPropagation();
      // Instant feedback: flip the tapped row now; the products, counts and
      // available options follow from the background fetch.
      var wasActive = row.hasAttribute('data-filter-active');
      if (!row.hasAttribute('data-pif-opt')) {
        row.setAttribute('data-pif-opt', wasActive ? 'on' : 'off');
        row.setAttribute('data-pif-href0', row.getAttribute('href'));
      }
      var nowActive = !wasActive;
      var target;
      if (intendedUrl === null) {
        target = targetFromLink(row.getAttribute('data-pif-href0'), true);
      } else {
        var origOn = row.getAttribute('data-pif-opt') === 'on';
        target = urlFromEntries(applyDelta(entriesOf(intendedUrl), rowDelta(row), nowActive === origOn));
      }
      paintRow(row, nowActive);
      intendedUrl = target;
      loadState(target, { optimistic: true });
      return;
    }
    var chip = t.closest ? t.closest(SEL.chip) : null;
    if (chip && inScope(chip)) {
      e.preventDefault();
      e.stopPropagation();
      loadState(targetFromLink(chip.getAttribute('href'), true), {});
      return;
    }
    var clear = t.closest ? t.closest(SEL.clear) : null;
    if (clear && inScope(clear)) {
      e.preventDefault();
      e.stopPropagation();
      loadState(targetFromLink(clear.getAttribute('href'), true), {});
      return;
    }
    var sb = t.closest ? t.closest(SEL.sortBtn) : null;
    if (sb && inScope(sb) && !sb.disabled) {
      e.preventDefault();
      e.stopPropagation();
      sortTo(sb.value || sb.getAttribute('value'));
      return;
    }
    var pg = t.closest ? t.closest(SEL.page) : null;
    if (pg && inScope(pg)) {
      e.preventDefault();
      e.stopPropagation();
      loadState(targetFromLink(pg.getAttribute('href'), false), { scrollToTop: true });
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.matches('[data-pm-native-limit]') && inScope(t)) {
      e.preventDefault(); e.stopPropagation();
      var sizeURL = new URL(intendedUrl || renderedUrl, window.location.origin);
      sizeURL.searchParams.set('view', 'native-' + t.value);
      sizeURL.searchParams.delete('page');
      loadState(sizeURL.pathname + sizeURL.search, {});
      return;
    }
    if (t.matches && t.matches(SEL.sortSel) && inScope(t)) {
      e.preventDefault();
      e.stopPropagation();
      sortTo(t.value);
    }
  }, true);

  /* Manual drawer opens after a swap get the same height normalization
   * (empire rebuilds the modal lazily on open). Never intercepts. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var fb = t.closest ? t.closest(SEL.filterBtn) : null;
    if (!fb || !inScope(fb)) return;
    var nid = reqSeq;
    setTimeout(function () {
      if (nid !== reqSeq || inFlight) return;
      normalizeModalGroups(nid);
      queueDock();
      updateShowCount();
      syncFooterClone();
    }, 400);
  }, true);

  function sortTo(value) {
    if (!value) return;
    initSortState();
    // Already the shown sort: just close the sheet, no fetch.
    if (value === (activeSortValue() || renderedSort)) { closeSortSheet(); return; }
    var u = new URL(intendedUrl || (window.location.pathname + window.location.search + window.location.hash), window.location.origin);
    u.searchParams.set('sort_by', value);
    u.searchParams.delete('page');
    var target = u.pathname + u.search + u.hash;
    paintSort(value);
    closeSortSheet();
    intendedUrl = target;
    loadState(target, { optimistic: true });
  }

  // The selected Sort option is a disabled button (no click events), so its
  // row is the hit target (pointer-events:none on the button): tapping the
  // already-applied option closes the sheet.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.classList || !t.classList.contains('utils-sortby--modal-item') || !inScope(t)) return;
    var b = t.querySelector('[data-productgrid-trigger-sort-button]');
    if (b && b.disabled) {
      e.preventDefault();
      e.stopPropagation();
      closeSortSheet();
    }
  }, true);

  window.addEventListener('popstate', function () {
    // Back/Forward restores the exact results + filter state for the URL.

    loadState(window.location.pathname + window.location.search + window.location.hash, { push: false });
  });

  try {
    window.history.replaceState({ pif: true, url: window.location.pathname + window.location.search + window.location.hash }, '');
  } catch (e) {}
  // The Sort markup is rendered after this script tag, so read the applied
  // sort once the DOM exists (and again lazily on first use).
  function initSortState() {
    if (renderedSort) return;
    renderedSort = activeSortValue() || (function () {
      var sel = scopeQuery(SEL.sortSel);
      return sel ? sel.value : null;
    })();
    if (renderedSort) paintSort(renderedSort);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSortState);
  else initSortState();

  queueDock();
  updateShowCount();
})();
